module.exports = __webpack_public_path__ + "static/img/wxjieshao.36cdf20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wxjieshao.png
// module id = fbyH
// module chunks = 1